import { render, staticRenderFns } from "./AnnounceDetail.vue?vue&type=template&id=5627bb51&"
import script from "./AnnounceDetail.vue?vue&type=script&lang=js&"
export * from "./AnnounceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports